const dashboardRouteFormatter = (url) => `buzzAppCentral/${url}`;

export const getManagementAppPanelRoute = () =>
  dashboardRouteFormatter('managementSchoolPanel');

export const getDiscoverAppUserPanelRoute = () =>
  dashboardRouteFormatter('userPanel');

export const getDiscoveryUserRoute = () =>
  dashboardRouteFormatter('discoveryUsers');

// ---------------------------------------------------
const whitelabeledRouteFormatter = (url) => `buzzAppCentral/${url}`;

export const getAllAppListRoute = () => whitelabeledRouteFormatter('apps');

export const postAllAppListRoute = (id) =>
  whitelabeledRouteFormatter(`apps/${id}`);

export const patchAppListRoute = (id) =>
  whitelabeledRouteFormatter(`apps/sha/${id}`);

export const patchAppAproveReject = (id) =>
  whitelabeledRouteFormatter(`apps/${id}`);

// ---------------------------------------------------
const hashtagsRouteFormatter = (url) => `hashtags/${url}`;

export const getHashtagsRoute = () => hashtagsRouteFormatter('');

export const getAllhashtagsRoute = () => hashtagsRouteFormatter('all');

export const postHashtagsRoute = () => hashtagsRouteFormatter('');

export const editHashtagsRoute = (id) => hashtagsRouteFormatter(`${id}`);
